import AddressBook from '../views/AddressBook.vue';
import AuditLog from '../views/AuditLog.vue';
import Departments from '../views/Departments.vue';
import FormulaSettings from '../views/FormulaSettings.vue';
import IndicatorVisibility from '../views/IndicatorVisibility.vue';
import ListOfUsersOnNews from '../views/ListOfUsersOnNews.vue';
import NotificationSettings from '../views/NotificationSettings.vue';
import OpenClientMenu from '../views/OpenClientMenu.vue';
import OrganizationCard from '../views/OrganizationCard.vue';
import OrganizationsPage from '../views/OrganizationsPage.vue';
import Permissions from '../views/Permissions.vue';
import RoleCard from '../views/RoleCard.vue';
import RoleGroupCard from '../views/RoleGroupCard.vue';
import Roles from '../views/Roles.vue';
import SystemSettings from '../views/Settings.vue';
import StatisticsPortal from '../views/StatisticsPortal.vue';
import StatisticsPublic from '../views/StatisticsPublic.vue';
import UserNotifications from '../views/UserNotifications.vue';

export const routes = [
  {
    path: '/admin/FormulaSettings',
    name: 'FormulaSettings',
    component: FormulaSettings,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/organizations',
    name: 'Organizations',
    component: OrganizationsPage,
  },
  {
    path: '/admin/organizations/:action/:id',
    name: 'OrganizationCard',
    component: OrganizationCard,
  },
  {
    path: '/admin/departments',
    name: 'Departments',
    component: Departments,
  },
  {
    path: '/admin/UsersOnNews',
    name: 'usersOnNews',
    component: ListOfUsersOnNews,
    meta: { isAdmin: true },
  },
  //Страница для работников-разработчиков
  {
    path: '/admin/permissions-neochevidniy-path',
    name: 'Permissions',
    component: Permissions,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/audit',
    name: 'AuditLog',
    component: AuditLog,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/openClientMenu',
    name: 'OpenClientMenu',
    component: OpenClientMenu,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/Roles',
    name: 'Roles',
    component: Roles,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/roles/:action/:id',
    name: 'RoleCard',
    component: RoleCard,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/rolegroups/:action/:id',
    name: 'RoleGroupCard',
    component: RoleGroupCard,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/IndicatorVisibility',
    name: 'IndicatorVisibility',
    component: IndicatorVisibility,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/settings',
    name: 'SystemSettings',
    component: SystemSettings,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/userNotifications',
    name: 'UserNotification',
    component: UserNotifications,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/notificationSettings',
    name: 'NotificationSettings',
    component: NotificationSettings,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/addressBook',
    name: 'AddressBook',
    component: AddressBook,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/statistics/public',
    name: 'StatisticsPublic',
    component: StatisticsPublic,
  },
  {
    path: '/admin/statistics/portal',
    name: 'StatisticsPortal',
    component: StatisticsPortal,
  },
];
